import { Close } from "@mui/icons-material";
import { Box, Dialog, DialogContent, DialogTitle, IconButton, Typography } from "@mui/material";

interface ResourceDialogProps{
    resource: string;
    setResource: React.Dispatch<React.SetStateAction<string>>;
}

export default function ResourceDialog({ resource, setResource }: ResourceDialogProps) {
    return (
        <Dialog 
            open={Boolean(resource)} 
            onClose={() => setResource('')} 
            maxWidth="md" 
            fullWidth
            PaperProps={{
                sx: {
                    borderRadius: 3,
                    boxShadow: "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)",
                }
            }}
        >
            <DialogTitle sx={{ pb: 1 }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <IconButton 
                        onClick={() => setResource('')}
                        sx={{
                            color: "#6b7280",
                            '&:hover': {
                                backgroundColor: "#f3f4f6",
                            }
                        }}
                    >
                        <Close />
                    </IconButton>
                </Box>
            </DialogTitle>
            <DialogContent sx={{ pt: 1 }}>
                <img
                    src={resource}
                    alt="resource"
                    style={{ 
                        width: "100%", 
                        borderRadius: "8px",
                        boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.1)"
                    }}
                />
            </DialogContent>
        </Dialog>
    );
}